import { Accessibility, Calendar, Building2, Home, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const services = [
  {
    icon: Accessibility,
    title: "Wheelchair Transportation Service",
    description: "Wheelchair-accessible vans with ramps and secure tie-downs for safe, comfortable rides.",
  },
  {
    icon: Calendar,
    title: "Medical Appointment Rides",
    description: "Reliable transport to doctor visits, dialysis, therapy sessions, and routine checkups.",
  },
  {
    icon: Building2,
    title: "Hospital Discharge Transportation",
    description: "Safe rides home after hospital stays, surgeries, or outpatient procedures.",
  },
  {
    icon: Home,
    title: "Assisted Living Transportation",
    description: "Scheduled rides for assisted living and nursing home residents to medical appointments.",
  },
  {
    icon: MapPin,
    title: "Long Distance Medical Transport",
    description: "Comfortable long-distance rides to specialty clinics and medical centers across Oregon.",
  },
];

const ServicesOverview = () => {
  return (
    <section className="py-14 sm:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground mb-3 sm:mb-4">
            Our Medical Transportation Services
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our medical transportation services — from wheelchair rides to hospital discharges across Portland, OR
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <Card
              key={index}
              className="border-border rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="pt-6 sm:pt-8 pb-5 sm:pb-6 px-5 sm:px-6 text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4 sm:mb-5 mx-auto">
                  <service.icon className="h-7 w-7 sm:h-8 sm:w-8 text-primary" />
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2 sm:mb-3">
                  {service.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
